<template>
  <SortableHeaderLabel :params="params" />
</template>

<script>
import SortableHeaderLabel from './SortableHeaderLabel.vue'

export default {
  components: {
    SortableHeaderLabel,
  },
}
</script>
